import buildBasePayload from './buildBasePayload.js';

// Type 3 supports no uploads and its create schema is `additionalProperties: false`,
// so adding any building-model upload field here fails validation on POST /model.
const calculateType3CopyModelPostPayload = (baseModel, createdById, orgId, permissions) =>
  buildBasePayload(baseModel, createdById, orgId, permissions);

export default calculateType3CopyModelPostPayload;
